import React from "react";
import { Navigate,  } from "react-router-dom";

const PrivateRoute = ({ children }) => {
  
  const token = localStorage.getItem("token");
  const apikey = localStorage.getItem("apikey");
  if (token && apikey) {
    return children;
  } else {
    console.log('please login');
  return < Navigate to="/login"/>
  }
};

export default PrivateRoute;
